export default __webpack_public_path__ + "static/media/logo-title.b99c51f7.svg";